require('./openYoungDashboardChildContent.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKLink } = require('commonsComponents/OKLink');
const OKTag = require('components/commons/OKTag/OKTag');

// @ components
const OpenYoungDashboardProductItem = require("components/openYoungDashboard/openYoungDashboardProductItem/openYoungDashboardProductItem");

// @ utilities
const { getPublicSiteUrl } = require('core/apiURLBuilder');
const { getLastNChars } = require('utilities/stringHelper');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

class OpenYoungDashboardChildContent extends React.Component {
    constructor(props) {
        super(props);
        this.buildChildAccountInfo = this.buildChildAccountInfo.bind(this);
        this.buildChildCardInfo = this.buildChildCardInfo.bind(this);
    }

    buildChildAccountInfo() {
        const { immAccountDetails, immAccounts } = this.props;
        const childAccountContractNumber = !!immAccountDetails ? immAccountDetails.get('contractNumber') : '';
        const immAccountsById = immAccounts.get('byId');
        const immAccountsByOrder = immAccounts.get('byOrder');
        let accountContent;
        let accountWaferContent;
        if (!!childAccountContractNumber) {
            const selectedAccountId = immAccountsByOrder.find(accountId => {
                const immAccount = immAccountsById.get(accountId);
                return immAccount.get('newContractNumber') === childAccountContractNumber;
            });
            const selectedImmAccount = immAccountsById.get(selectedAccountId);
            accountContent = (
                <OpenYoungDashboardProductItem
                    amount={selectedImmAccount.getIn(['balance', 'amount'])}
                    currency={selectedImmAccount.getIn(['balance', 'currency'])}
                    title={selectedImmAccount.get('alias')}
                    titleSmall={getLastNChars(selectedImmAccount.get('iban'), 4)}
                />
            );
        } else {
            accountWaferContent = (
                <div className="open-young-dashboard-child-content__title-container">
                    <div className="open-young-dashboard-child-content__title">
                        <FormattedText
                            className="open-young-dashboard-child-content__title-text"
                            value="openYoungDashboardView-openYoungDashboardView_hireAccountTitle"
                        />
                        <OKTag content="openYoungDashboardView-openYoungDashboardView_contratarTag" />
                    </div>
                    <FormattedText
                        className="open-young-dashboard-child-content__subtitle"
                        value="openYoungDashboardView-openYoungDashboardView_hireAccountSubtitle"
                    />
                </div>
            );
        }
        return { accountContent, accountWaferContent };
    }

    buildChildCardInfo() {
        const { immCardDetails, immCards } = this.props;
        const childCardContractNumber = !!immCardDetails ? immCardDetails.get('contractNumber') : '';
        const immCardsById = immCards.get('byId');
        const immCardsByOrder = immCards.get('byOrder');
        let cardContent;
        let cardWaferContent;
        if (!!childCardContractNumber) {
            const selectedCardId = immCardsByOrder.find(cardId => {
                const immCard = immCardsById.get(cardId);
                return immCard.getIn(['contract', 'number']) === childCardContractNumber;
            });
            const selectedImmCard = immCardsById.get(selectedCardId);
            cardContent = (
                <OpenYoungDashboardProductItem
                    amount={selectedImmCard.getIn(['balanceDrawn', 'amount'])}
                    currency={selectedImmCard.getIn(['balanceDrawn', 'currency'])}
                    title={selectedImmCard.getIn(['alias', 'current'])}
                    titleSmall={getLastNChars(selectedImmCard.get('number'), 4)}
                />
            );
        } else {
            const publicSiteUrl = getPublicSiteUrl();
            cardWaferContent = (
                <div className="open-young-dashboard-child-content__wafer-container">
                    <div className="open-young-dashboard-child-content__image-container">
                        <img className="open-young-dashboard-child-content__image" src={`${publicSiteUrl}/assets/2017-05/OPEN_YOUNG_PREPAID_240.png`} alt="hire-card" />
                    </div>
                    <div className="open-young-dashboard-child-content__wafer-title">
                        <div className="open-young-dashboard-child-content__wafer-text">
                            <FormattedText
                                value="openYoungDashboardView-openYoungDashboardView_hireCardTitle"
                            />
                            &nbsp;
                            <FormattedText
                                className="open-young-dashboard-child-content__wafer-subtitle"
                                value="openYoungDashboardView-openYoungDashboardView_hireCardSubtitle"
                            />
                        </div>
                        <OKLink modifier="complementary" to="/myprofile/hire/card/open-young" >
                            <FormattedText
                                value="openYoungDashboardView-openYoungDashboardView_applyFor"
                            />
                        </OKLink>
                    </div>

                </div>
            );
        }
        return { cardContent, cardWaferContent };
    }

    render() {
        const { accountContent, accountWaferContent } = this.buildChildAccountInfo();
        const { cardContent, cardWaferContent } = this.buildChildCardInfo();
        const headerTitle = <FormattedText value="openYoungDashboardView-openYoungDashboardView_productTitle" />;

        return (
            <div className="open-young-dashboard-child-content">
                <article className="open-young-dashboard-child-content__header">
                    <header>
                        <OKBoxTitle value={headerTitle} />
                    </header>
                </article>
                <div className="open-young-dashboard-child-content--information">
                    {cardContent}
                    {cardWaferContent}
                    {accountContent}
                    {accountWaferContent}
                </div>
            </div>
        );
    }
}
OpenYoungDashboardChildContent.propTypes = {
    immAccountDetails: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCardDetails: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
};
module.exports = OpenYoungDashboardChildContent;
